import { HgSupportedLanguage } from '@smg-real-estate/domus';

// The GGA Maur Widget should only be displayed for certain zip codes
const supportedZips = [
  '8124',
  '8123',
  '8122',
  '8127',
  '8126',
  '8132',
  '8133',
  '8117',
  '8118',
  '8121',
  '8603',
  '8606',
  '8600',
  '8610',
  '8700',
  '8304',
];

export function isGgaMaurEnabled(listingZip: string, language: HgSupportedLanguage): boolean {
  return supportedZips.includes(listingZip) && language === HgSupportedLanguage.DE;
}
